import {
  CHECK_HEALTH_STATUS,
  DISPLAY_DOWNTIME
} from '../actions/error-actions';

export default function downtimeReducer(state = null, action) {
  const { type, error, messages } = action;

  if (type === CHECK_HEALTH_STATUS) {
    return { ...state, messages: [] };
  }

  if (type === DISPLAY_DOWNTIME) {
    return { ...state, messages };
  }

  if (error) {
    return error;
  }

  return state;
}
